import {OptionGroup} from './option-group';
import {Image} from './image';
export class Scene {

  id: number;
  displayName: string;
  startTime: number;
  endTime: number;
  showOptions: boolean;
  image: Image;
  optionGroups: Array<OptionGroup> = Array<OptionGroup>();

  static fromJSON(json: SceneJSON): Scene {
    const scene = Object.assign(Object.create(Scene.prototype), json, {
      optionGroups: JSON.parse(json.optionGroups)
    });

    scene.optionGroups = [];
    const groups = JSON.parse(json.optionGroups);
    for (const group of groups) {
      scene.optionGroups.push(OptionGroup.fromJSON(group));
    }

    if (json.image) {
      scene.image = Image.fromJSON(JSON.parse(json.image));
    }

    return scene;
  }

  toJSON(): SceneJSON {
    return Object.assign({}, this, {
      image: JSON.stringify(this.image),
      optionGroups: JSON.stringify(this.optionGroups)
    });
  }

  constructor(public data: any) {
    const json: JSON = data;

    this.id = json['id'];
    this.displayName = json['displayName'];
    this.startTime = json['start'];
    this.endTime = json['end'];
    this.showOptions = json['showOptions'];
    if (json['image']) {
      this.image = new Image(json['image']);
    }
  }

  findOptionGroupById(groupId: number) {
    for (const group of this.optionGroups) {
      if (group.id === groupId) {
        return group;
      }
    }
    return null;
  }

  hasOptionsToDisplay() {
    if (!this.showOptions) {
      return false;
    }
    return this.hasOptionsDownloaded();
  }

  hasOptionsDownloaded() {
    if (this.optionGroups.length) {
      for (const og of this.optionGroups) {
        if (og.options.length > 0) {
          return true;
        }
      }
    }
    return false;
  }
}

export interface SceneJSON {
  id: number;
  displayName: string;
  startTime: number;
  endTime: number;
  showOptions: boolean;
  image: string;
  optionGroups: string;
}



// WEBPACK FOOTER //
// ./src/app/model/scene.ts